import { Box } from "@mui/material";
import { CheckCircleRounded, RadioButtonUncheckedRounded } from "@mui/icons-material";
import { PASSWORD_RULES } from "utils/passwordRules";

// Live password requirements, so users know what is needed BEFORE failing. The rules are the
// server's own (utils/passwordRules.js); used on sign up and reset password, both white cards.
const PasswordChecklist = ({ password, sx }) => (
  <Box sx={{ pl: 0.5, ...sx }}>
    {PASSWORD_RULES.map((rule) => {
      const ok = rule.test(password || "");
      return (
        <Box
          key={rule.id}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            fontSize: 13,
            lineHeight: 1.7,
            // Explicit colors: this app's theme tokens (text.secondary) are
            // light (dark-theme palette) and vanish on the white card.
            color: ok ? "#1e8e3e" : "#5f6b7a",
          }}
        >
          {ok ? (
            <CheckCircleRounded sx={{ fontSize: 16 }} />
          ) : (
            <RadioButtonUncheckedRounded sx={{ fontSize: 16 }} />
          )}
          <span>{rule.label}</span>
        </Box>
      );
    })}
  </Box>
);

export default PasswordChecklist;
